<template lang="pug">
.simpliciti_logo(:style="style")
  img(v-show="clientLogoBase64==='default'" :src="simplicitiSquareLogo")
  img(v-show="hasCustomLogo" :src="clientLogoBase64")
  b-spinner(
        v-show="!clientLogoBase64"
        class="loader"
        variant="light"
        type="grow"
        small
        style="width: 2rem; height: 2rem")
      
</template>
<script>
import simplicitiSquareLogo from '@c/shared/SimplicitiLogo/simpliciti_square_logo.svg'
export default {
  data() {
    return {
      simplicitiSquareLogo,
    }
  },
  computed: {
    clientLogoBase64() {
      return this.$store.getters['settings/getParameter']('clientLogoBase64')
    },
    hasCustomLogo() {
      return (
        !!this.clientLogoBase64 &&
        this.clientLogoBase64 !== 'default' &&
        this.clientLogoBase64.includes('base64')
      )
    },
    style() {
      switch (this.clientLogoBase64) {
        case 'default':
          return `background-color:transparent;`
        case '':
        default:
          return `background-color:white;`
      }
    },
  },
  created() {
    this.$store.dispatch('settings/syncClientLogo')
  },
}
</script>
<style lang="scss" scoped>
.simpliciti_logo {
  max-height: 50px;
  height: 50px;

  img {
    max-width: 100%;
    max-height: 100%;
    padding: 5px;
  }
}
</style>
